import React, { Component } from "react";
import DATEPICKER_OR from "../custom-form/custom-date-picker.component";
import Moment from 'moment';
import CustomExportButton from "../custom-form/custom-export-button.component";
import Translation from '../../common/translation/translation.component';
import "../graph/usagespend-layout.component.css"
import { validateAccessModule } from "../../../utils/helpers.utils";
import { ACCESS_MODULE, MATRIX_INDICATOR } from "../../../utils/rbac-constants.utils";
class UsageSpendLayout extends Component {
    constructor(props){
        super(props);
        this.state={
            startDate:null,
            dateFormat:"MMMM yyyy"
        }
    }

    SelectDatePicker(date) {  
        const formatDate = Moment(date).format(this.state.dateFormat);     
        this.setState({
            startDate: date
        });      
        this.props.selectDatePicker(formatDate);
    }


    render() {
        let isReadOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardR])
        let isReadAndExtractOnly = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRE])
        let isReadAndWrite = !validateAccessModule(MATRIX_INDICATOR.MatrixId, [ACCESS_MODULE.MatrixIdFinanceContractDashboardRW])

        return(
            <div className="usage-spend-layout-container date-picker-main-container">
                <div className="component-form-filter">
                    
                     <DATEPICKER_OR 
                        label={<Translation translationKey="select_date" />}
                        startDate={this.state.startDate}                       
                        selectedDate={(date) => this.SelectDatePicker(date)} 
                        isDisable={false}
                        dateFormat={this.state.dateFormat}
                        placeholder={Moment(new Date()).local().format('MMMM yyyy')}
                     />    
                     <div className="usage-spend-export-container">
                        {!isReadOnly &&
                            <CustomExportButton
                                imageRef={this.props.imageRef}
                                circuitId={this.props.circuitId}
                                circuitCode={this.props.circuitCode}
                                printData={this.props.printData}
                                renderKey={this.state.renderKey}
                                isReadOnly={isReadOnly}
                                isReadAndExtractOnly={isReadAndExtractOnly}
                                isReadAndWrite={isReadAndWrite}
                            />
                        }
                    </div>               
                </div>
                {this.props.children}
            </div>
        )
   }
}

export default UsageSpendLayout;